import { IconV1 } from 'common/icon/iconV1.js';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from 'redux-state/configure-store.js';
import { IRepoState } from 'redux-state/rootReducer.js';
import { REDUX_SEARCH_OPEN_OVERLAY } from 'redux-state/search/reducer.js';
import { DEFAULT_SEARCH_OVERLAY_TOP } from 'utilities/css-variables.js';
import { messageLog } from 'utilities/helpers/logger/message-logger.js';
import { getDocument } from 'utilities/window.js';
import { SEARCH_BAR_DEFAULT_TEXT } from './search-bar.js';

export const SearchBarInput = () => {
  const appDispatch = useAppDispatch();
  const searchLabel = useSelector((state: IRepoState) => state.LAYOUT.screen?.searchLabel);
  const [label, setLabel] = useState(searchLabel);

  const onMouseOverHandler = () => setLabel(SEARCH_BAR_DEFAULT_TEXT);
  const onMouseOutHandler = () => setLabel(searchLabel);

  const showSearchOverlay = () => {
    const mainNavigation = getDocument()?.body?.querySelector?.('.Nav--primary');
    let hasMainNavigation = false;

    if (mainNavigation) {
      const top = mainNavigation.getBoundingClientRect().top;

      if (top > -DEFAULT_SEARCH_OVERLAY_TOP) {
        hasMainNavigation = true;
      }
    }

    // Offset by the MenuNavigation if it's currently in view, otherwise the search bar
    // sits at the top
    const topOffset = hasMainNavigation ? DEFAULT_SEARCH_OVERLAY_TOP : 0;
    messageLog.info(`DEFAULT SEARCH TOP: ${DEFAULT_SEARCH_OVERLAY_TOP}`);
    appDispatch(REDUX_SEARCH_OPEN_OVERLAY({ offsetTop: topOffset }));
  };

  useEffect(() => {
    setLabel(searchLabel);
  }, [searchLabel, setLabel]);

  return (
    <div className="SearchBar-input-container">
      <h1 className="SearchBar-actions">
        <button
          className="SearchBar-actions-find"
          title="Search"
          onClick={showSearchOverlay}
          onMouseOver={onMouseOverHandler}
          onMouseOut={onMouseOutHandler}
        >
          <span>{label || SEARCH_BAR_DEFAULT_TEXT}</span>
        </button>
        <div className="SearchBar-actions-icon">
          <IconV1 icon="search" />
        </div>
      </h1>
    </div>
  );
};
